import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import UniversityDropdown from 'src/views/admin/UniversityDropdown';
import ScholarshipProgramDropdown from 'src/components/ScholarshipProgramDropdown';
import EducationPhaseDropdown from 'src/views/admin/EducationPhaseDropdown';
import List from './List';
import {EducationPhase} from 'src/types/enums';
import styles from './styles.module.scss';
import Checkbox from 'shared/components/checkbox';

const TimeSensitiveItemTypes = (): React.ReactElement => {
  const [educationPhase, setEducationPhase] = useState(EducationPhase.UNDERGRADUATE);
  const [scholarshipProgram, setScholarshipProgram] = useState(null);
  const [sponsorId, setSponsorId] = useState(null);
  const [showGlobalItems, setShowGlobalItems] = useState(true);

  const handleShowGlobalItems = (e): void => {
    setShowGlobalItems(e.target.checked);
    setSponsorId(null);
    setScholarshipProgram(null);
  };

  return (
    <>
      <div className={styles.headerDiv}>
        <h4 className={styles.header}>Search for TimeSensitiveItemType</h4>
        <Link to="/admin/tools/time-sensitive-item-types/new" className={styles.addNew}>
          Add New
        </Link>
      </div>
      <Checkbox
        checked={showGlobalItems}
        onChange={handleShowGlobalItems}
        label="Show time sensitive item types that don't belong to a specific university"
      />
      <UniversityDropdown onChange={setSponsorId} value={sponsorId} disabled={showGlobalItems} />
      <EducationPhaseDropdown onChange={setEducationPhase} value={educationPhase} />
      <ScholarshipProgramDropdown
        sponsorId={sponsorId}
        educationPhase={educationPhase}
        onChange={setScholarshipProgram}
        value={scholarshipProgram}
        disabled={showGlobalItems}
      />
      <List
        globalItems={showGlobalItems}
        sponsorId={sponsorId}
        scholarshipProgram={scholarshipProgram}
      />
    </>
  );
};

export default TimeSensitiveItemTypes;
